<app-edit-popup
    *ngIf="view == 'edit-popup'"
    [data]="dataToEdit"
    (closeView)="changeView('home')"
    (confirm)="editData($event)">
</app-edit-popup>

<div class="L-12 M-12 S-12 columns" [ngClass]="{'no-gap': noGap, 'h-100': height100}">
	<div class="L-12 M-12 S-12 columns" [ngClass]="{'no-gap': noGap, 'm-0': noMargin, 'h-100': height100, 'new-table': newStyle, 'detail-table': detailStyle, 'TableConteiner': !newStyle && !detailStyle }" [ngStyle]="{'max-height': maxHeight ? maxHeight : '', 'margin-bottom': marBottom ? marBottom : ''}">
		<table class="scene" [ngClass]="{'full':full, 'm-0': noMargin, 'w-100': w100 }">
			<caption class="caption" *ngIf="caption">
				<ng-container *ngIf="!searchTextInTable">
					<span>{{ captionData.title | translate }}</span>
					<span *ngIf="captionData.accordion && !hideContent" (click)="hideContent = !hideContent" class="icon-caption-acc material-icons">
						keyboard_arrow_up 
					</span>
					<span *ngIf="captionData.accordion && hideContent" (click)="hideContent = !hideContent" class="icon-caption-acc material-icons">
						keyboard_arrow_down
					</span>
					<span (click)="actionIconCaption($event)" *ngIf="captionData.icon" class="icon-caption material-icons">
						{{ captionData.iconTx }}
					</span>
				</ng-container>
				<ng-container *ngIf="searchTextInTable">
					<input type="text" (input)="actionSearchText()" class="inp-search" [placeholder]="'Search' | translate" [(ngModel)]="textSearch">
				</ng-container>
				<div (click)="searchTextInTable = !searchTextInTable; restartData()" class="search-wrapper">
					<div class="search pointer"></div>
				</div>
			</caption>
			<thead>
				<tr [ngClass]="{ 'th-cap': caption }">
					<th *ngIf="addCheck" class="addCheck">
						<input type="checkbox" name="checked_all" [(ngModel)]="checked_all" (ngModelChange)="check_list()">
					</th>
					<ng-container *ngFor="let head of headersShow; let i = index">
						<th [ngClass]="{'sticky-left': head.sticky}" [ngStyle]="{left: head.sticky? addCheck ? head.sticky_value + (i*3) + 37 + 'px' : head.sticky_value + (i*3) + 'px':''}">
							<div (click)="ordertable(head)">
								<ng-container *ngTemplateOutlet="tableHeaders; context{'head': head}"></ng-container>
							</div>
						</th>
					</ng-container>
					<th *ngIf="showMobileMenu && (_gS.isMobile$ | async)" class="option-table sticky-right">&nbsp;</th>
				</tr>
			</thead>
			<tbody *ngIf="!hideContent && !activateDragAndDrop">
				<ng-container *ngFor="let item of list | slice:sliceStart:(sliceStart + sliceSize) ; let i = index">
					<tr *ngIf="item" (dblclick)="dblclick($event, item)" (contextmenu)="_gS.rigthClick($event, 3); selectRow(item)" (click)="click($event, item)">
						<td *ngIf="addCheck" class="addCheck">
							<div>
								<input type="checkbox" name="{{'checked_' + i}}" [(ngModel)]="item.checked" (ngModelChange)="changeBulk(item)">
							</div>
						</td>
						<ng-container *ngFor="let head of headersShow; let i = index">
							<td [ngStyle]="{left: head.sticky? addCheck ? head.sticky_value + (i*3) + 37 + 'px' : head.sticky_value + (i*3) + 'px':''}" [ngClass]="{'td-row-child': head.type == 'childrenRows'}" [class]="checkClass(item, head)">
								<div *ngIf="head.type != 'childrenRows'" [class]="head.class" [ngStyle]="{'width.px': head.width ? head.width  :'auto', 'margin': '0 auto' }" [ngClass]="{'hasElement': (head.type == 'list' || head.type == 'list_back_translate'), 'flex align-center': head.hasMiniImage}">
									<span class="number" *ngIf="(head.type == 'list' || head.type == 'list_back_translate') && getValue(item, head, true)">{{getValue(item, head, true)}}</span>
									<div class="box-img" *ngIf="head.hasMiniImage">
										<img *ngIf="item[head.value_image]" [src]="item[head.value_image]" imageLoader (load)="_gS.loadImage()">
										<div *ngIf="!item[head.value_image]">
											<span>{{item[head.value_initials].toLowerCase() | abbreviation}}</span>
										</div>
									</div>
									<ng-container *ngIf="head.type != 'link' && head.type != 'user_list' && !newStyle && head.type != 'progress_bar' && head.type != 'title_subtitle' && head.type != 'options' && head.type != 'childrenRows'">
										<span [class]="checkColorClass(item, head)">
											{{getValue(item, head) | mexTranslate: currentProject}}
										</span>
										<span *ngIf="head.showTrIcon" (click)="onIconTr(item)" class="tr-icon material-icons" [class]="checkColorIcon(item, head)">
											{{ head.iconName }}
										</span>
									</ng-container>
									<ng-container *ngIf="head.type == 'link' && head.value">
										<a target="_blank" *ngIf="item[head.href]" style="color:rgb(10, 169, 238);" [href]="item[head.href]" (contextmenu)="$event.stopPropagation()">{{getValue(item, head)}}</a> 
										<ng-container
											*ngIf="!item[head.href]">
											{{getValue(item, head)}}
										</ng-container>
									</ng-container>
									<ng-container *ngIf="head.type == 'comments'">
										<div (click)="onClickComment($event, item)" >
											<span class="material-icons filter-btn-comment" style="color:rgb(10, 169, 238);">{{item[head.value_initials].length  > 0 ?  "forum" : "add_comment"}} </span>											
												<a  class= "filter-btn-comment-total" >
													{{item[head.value_initials].length || ""}}
												</a>
										</div>
									</ng-container>
									<ng-container *ngIf="head.type == 'user_list'">
										<ng-container *ngFor="let user of item[head.list]| slice: 0:2">
											<div class="box-img box-imgg-asset" >
												<img *ngIf="user[head.value_image]" [src]="user[head.value_image]" imageLoader (load)="_gS.loadImage()">
												<div *ngIf="!user[head.value_image]" (mouseleave)="_gS.hidemenu()" (mouseenter)="onClickUser($event, item, user)">
													<span>{{user[head.value_initials].toLowerCase() | slice: 0:2}}</span>
												</div>
											</div>
										</ng-container>
										<div *ngIf="item[head.list].length > 2" class="box-img box-imgg-asset" >
											<div (mouseleave)="_gS.hidemenu()" (mouseenter)="onClickUser($event, item)">
												<span>+{{item[head.list].length - 2}}</span>
											</div>
										</div>
									</ng-container>
								</div>	
								<ng-container *ngIf="head.type == 'childrenRows'">
									<table *ngIf="item[head.arrayName].length > 0 else noData" class="table-child">
										<ng-container *ngFor="let itemChild of item[head.arrayName]">
											<tr>
												<td class="child-td" *ngFor="let headChild of head.childrenRows" [ngStyle]="{'width.px': headChild.width}">
													<div class="dv-container">
														{{ itemChild[headChild.value] }}
														<span *ngIf="headChild.editField" (click)="editField(itemChild, headChild)" style="float: right" class="material-icons edit-field">edit_square</span>
													</div>
												</td>
											</tr>
										</ng-container>
									</table>
									<ng-template #noData>
										<span>--</span>
									</ng-template>
								</ng-container>
							</td>
						</ng-container>
						<td *ngIf="showMobileMenu && (_gS.isMobile$ | async)" class="option-table sticky-right" (click)="_gS.rigthClick($event, 3); $event.stopPropagation(); selectRow(item)">
							<div>
								<span class="material-icons more-menu circle filled">more_horiz</span>
							</div>
						</td>
					</tr>
				</ng-container>
			</tbody>
			<tbody *ngIf="!hideContent && activateDragAndDrop" cdkDropList (cdkDropListDropped)="drop($event)">
				<tr *ngFor="let item of list | slice:sliceStart:(sliceStart + sliceSize); let i = index" (dblclick)="dblclick($event, item)" cdkDrag>
				  <td *ngIf="addCheck" class="addCheck">
					<div>
					  <input type="checkbox" name="{{'checked_' + i}}" [(ngModel)]="item.checked" (ngModelChange)="changeBulk(item)">
					</div>
				  </td>
				  <ng-container *ngFor="let head of headersShow; let i = index">
					<td [ngStyle]="{left: head.sticky? addCheck ? head.sticky_value + (i*3) + 37 + 'px' : head.sticky_value + (i*3) + 'px':''}" [ngClass]="{'td-row-child': head.type == 'childrenRows'}" [class]="checkClass(item, head)">
					  <div *ngIf="head.type != 'childrenRows'" [class]="head.class" [ngStyle]="{'width.px': head.width ? head.width  :'auto', 'margin': '0 auto' }" [ngClass]="{'hasElement': (head.type == 'list' || head.type == 'list_back_translate'), 'flex align-center': head.hasMiniImage}">
						<span class="number" *ngIf="(head.type == 'list' || head.type == 'list_back_translate') && getValue(item, head, true)">{{getValue(item, head, true)}}</span>
						<div class="box-img" *ngIf="head.hasMiniImage">
						  <img *ngIf="item[head.value_image]" [src]="item[head.value_image]" imageLoader (load)="_gS.loadImage()">
						  <div *ngIf="!item[head.value_image]">
							<span>{{item[head.value_initials].toLowerCase() | abbreviation}}</span>
						  </div>
						</div>
						<ng-container *ngIf="head.type != 'link' && head.type != 'user_list' && !newStyle && head.type != 'progress_bar' && head.type != 'title_subtitle' && head.type != 'options' && head.type != 'childrenRows'">
						  <span [class]="checkColorClass(item, head)">
							{{getValue(item, head) | mexTranslate: currentProject}}
						  </span>
						  <span *ngIf="head.showTrIcon" (click)="onIconTr(item)" class="tr-icon material-icons" [class]="checkColorIcon(item, head)">
							{{ head.iconName }}
						  </span>
						</ng-container>
						<ng-container *ngIf="head.type == 'link' && head.value">
						  <a target="_blank" *ngIf="item[head.href]" style="color:rgb(10, 169, 238);" [href]="item[head.href]" (contextmenu)="$event.stopPropagation()">{{getValue(item, head)}}</a> 
						  <ng-container *ngIf="!item[head.href]">
							{{getValue(item, head)}}
						  </ng-container>
						</ng-container>
						<ng-container *ngIf="head.type == 'comments'">
						  <div (click)="onClickComment($event, item)" >
							<span class="material-icons filter-btn-comment" style="color:rgb(10, 169, 238);">{{item[head.value_initials].length  > 0 ?  "forum" : "add_comment"}} </span>											
							<a  class= "filter-btn-comment-total" >
							  {{item[head.value_initials].length || ""}}
							</a>
						  </div>
						</ng-container>
						<ng-container *ngIf="head.type == 'user_list'">
						  <ng-container *ngFor="let user of item[head.list]| slice: 0:2">
							<div class="box-img box-imgg-asset" >
							  <img *ngIf="user[head.value_image]" [src]="user[head.value_image]" imageLoader (load)="_gS.loadImage()">
							  <div *ngIf="!user[head.value_image]" (mouseleave)="_gS.hidemenu()" (mouseenter)="onClickUser($event, item, user)">
								<span>{{user[head.value_initials].toLowerCase() | slice: 0:2}}</span>
							  </div>
							</div>
						  </ng-container>
						  <div *ngIf="item[head.list].length > 2" class="box-img box-imgg-asset" >
							<div (mouseleave)="_gS.hidemenu()" (mouseenter)="onClickUser($event, item)">
							  <span>+{{item[head.list].length - 2}}</span>
							</div>
						  </div>
						</ng-container>
					  </div>	
					  <ng-container *ngIf="head.type == 'childrenRows'">
						<table *ngIf="item[head.arrayName].length > 0 else noData" class="table-child">
						  <ng-container *ngFor="let itemChild of item[head.arrayName]">
							<tr>
							  <td class="child-td" *ngFor="let headChild of head.childrenRows" [ngStyle]="{'width.px': headChild.width}">
								<div class="dv-container">
								  {{ itemChild[headChild.value] }}
								  <span *ngIf="headChild.editField" (click)="editField(itemChild, headChild)" style="float: right" class="material-icons edit-field">edit_square</span>
								</div>
							  </td>
							</tr>
						  </ng-container>
						</table>
						<ng-template #noData>
						  <span>--</span>
						</ng-template>
					  </ng-container>
					</td>
				  </ng-container>
				  <td *ngIf="showMobileMenu && (_gS.isMobile$ | async)" class="option-table sticky-right" (click)="_gS.rigthClick($event, 3); $event.stopPropagation(); selectRow(item)">
					<div>
					  <span class="material-icons more-menu circle filled">more_horiz</span>
					</div>
				  </td>
				</tr>
			  </tbody>
			<tfoot class="footer" *ngIf="footerValues">
				<tr>
					<td *ngFor="let head of headersShow; let i = index" [class]="head.class">
						{{ footerValues[head.value] ? '$' + (footerValues[head.value] | number:'0.2-2') : '--' }}
					</td>
				</tr>
			</tfoot>
		</table>
		<ng-container *ngIf="!list.length">
			<div class="no-record" [ngClass]="{ 'no-filter': !showClearButton }">
				<span *ngIf="showClearButton">{{"No matching record found" | translate}}</span>
				<ng-container *ngIf="!hideContent">
					<span *ngIf="!showClearButton">{{"No data available" | translate}}</span>
				</ng-container>
				<a *ngIf="showClearButton"
					class="clear-filters button"
					(click)="clearFilters()">
					{{'Clear filters' | translate}}
				</a>
			</div>
		</ng-container>
	</div>

	<div class="tablePagination" [ngClass]="{'relateivePagination': relativePagination}" *ngIf="pagination">
		<i class="first" (click)="changePagPosition('first')" *ngIf="printSliceStart > 0"></i>
		<i class="previous" (click)="changePagPosition('previous')" *ngIf="printSliceStart > 0"></i>
		<div class="values">
			{{printSliceStart + 1}} {{'To' | translate }} {{(printSliceStart + printSliceSize) < list.length ? (printSliceStart + printSliceSize) : list.length}} {{'Of' | translate}} {{list.length}}
		</div>
		<i class="next" (click)="changePagPosition('next')" *ngIf="printSliceStart + printSliceSize < list.length"></i>
		<i class="last" (click)="changePagPosition('last')" *ngIf="printSliceStart + printSliceSize < list.length"></i>
	</div>
</div>

<!-- Filter context -->
<div class="container-context-menu" *ngIf="showFilterMenu">
	<div *ngIf="_gS.showContext" class="contextmenuConteiner" (click)="_gS.hidemenu($event); showFilterMenu = false"></div>
	<div class="filter-contextmenu" [style.left]="_gS.contextmenux" [style.top]="_gS.contextmenuy" style="z-index: 1001;">
		<ng-container *ngTemplateOutlet="filterTemplate"></ng-container>
	</div>
</div>

<!-- Header template -->		
<ng-template #tableHeaders let-head="head">
	<div [ngClass]="{ 'bold-head': head.class == 'bold' }" [ngStyle]="{'width.px': head.width ? head.width  :'auto', 'margin': '0 auto' }">
		<ng-container *ngIf="head.canFilter" >
			<span *ngIf="head.isFilterActive" class="material-icons filter-btn active" (click)="filterTable($event, head)">filter_alt</span>
			<span *ngIf="!head.isFilterActive" class="material-icons filter-btn" (click)="filterTable($event, head)">filter_list</span>
		</ng-container>
		<span (click)="hideContent = !hideContent" *ngIf="head.icon" class="material-icons">
			keyboard_arrow_down
		</span>
		{{ head.name | translate | mexTranslate: currentProject }}
		<ng-container *ngIf="canOrder">
			<span *ngIf=" head.type == 'back_translate' ?  head.value + '_' + _gS.getLenguage()  == orderBy[0] : (head.value == orderBy[0] || (head.orderData == orderBy[0] && head.orderData))" class="Arrow down"></span>
			<span *ngIf=" head.type == 'back_translate' ?  head.value + '_' + _gS.getLenguage()  + ' DESC'  == orderBy[0] : (head.value + ' DESC' == orderBy[0] || (head.orderData + ' DESC' == orderBy[0] && head.orderData))" class="Arrow up"></span>
		</ng-container>
		<ng-container *ngIf="head.typeHead == 'progress-bar' && progressHead != null && progressHead != undefined">
			<app-progress-bar [detailsStyle]="true" [progress]="progressHead"></app-progress-bar>
		</ng-container>
	</div>
</ng-template>
